<ng-container *ngIf="authStore.isNewVitoguideFeaturesBannerVisible() | async">
  <div class="banner flex flex-row xs:flex-col justify-center items-center">
    <img class="image" src="/assets/img/installer-guy.png" />
    <div class="flex flex-col gap-[16px] xs:gap-[12px] justify-start items-start">
      <div class="header">{{ 'EVENT_BANNER.TITLE' | translate }}</div>
      <div class="feature-list flex flex-row xs:flex-col flex-wrap justify-start items-start">
        <div class="flex flex-row">
          <mat-icon class="check">check</mat-icon>
          <div class="feature">
            {{ 'EVENT_BANNER.FEATURE_1' | translate }}
          </div>
        </div>
        <div class="flex flex-row">
          <mat-icon class="check">check</mat-icon>
          <div class="feature">
            {{ 'EVENT_BANNER.FEATURE_2' | translate }}
          </div>
        </div>
        <div class="flex flex-row">
          <mat-icon class="check">check</mat-icon>
          <div class="feature">
            {{ 'EVENT_BANNER.FEATURE_3' | translate }}
          </div>
        </div>
        <div class="flex flex-row">
          <mat-icon class="check">check</mat-icon>
          <div class="feature">
            {{ 'EVENT_BANNER.FEATURE_5' | translate }}
          </div>
        </div>
        <div class="flex flex-row">
          <mat-icon class="check">check</mat-icon>
          <div class="feature">
            {{ 'EVENT_BANNER.FEATURE_6' | translate }}
          </div>
        </div>
        <div class="flex flex-row">
          <mat-icon class="check">check</mat-icon>
          <div class="feature">
            {{ 'EVENT_BANNER.FEATURE_4' | translate }}
          </div>
        </div>
      </div>
    </div>
    <button
      class="close-button"
      mat-icon-button
      gtm="onClose"
      gtmCategory="eventBanner"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-container>
